function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionPointRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.28 12.89a2.92 2.92 0 00-1.67-.44h-1.33v3.65h1.33a2.92 2.92 0 001.67-.43 1.54 1.54 0 00.63-1.38 1.58 1.58 0 00-.63-1.4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 2a14 14 0 100 28 14 14 0 000-28zm4.88 14.44a3.73 3.73 0 01-1.65 1.37c-.783.336-1.628.5-2.48.48h-1.47v3.8h-2.5V10.28h4a6.099 6.099 0 012.48.47 3.66 3.66 0 011.65 1.37 3.89 3.89 0 01.58 2.17 3.82 3.82 0 01-.61 2.15z",
    fill: props.color
  }));
}

export default SvgIconPromotionPointRexFilled;